import {
  flatten,
  isArray,
  isEmpty,
  isNil,
  isPlainObject,
  isString,
  map,
  uniq,
} from 'lodash-es'

interface ReferenceObject {
  _id: string
  contact?: string
  company?: string
  project?: string
}

export const getReferencedIds: (rawValue: unknown) => string[] = (
  rawValue: unknown,
) => {
  return uniq(getReferencedIdsWorker(rawValue))
}

const getReferencedIdsWorker: (rawValue: unknown) => string[] = (
  rawValue: unknown,
) => {
  if (isNil(rawValue)) {
    return []
  }

  if (isString(rawValue)) {
    return !isEmpty(rawValue) ? [rawValue] : []
  }

  if (isPlainObject(rawValue)) {
    const reference = rawValue as ReferenceObject
    if (reference.contact) {
      return [reference.contact]
    }
    if (reference.company) {
      return [reference.company]
    }
    if (reference.project) {
      return [reference.project]
    }
    console.warn('No reference id found')
    return []
  }

  if (isArray(rawValue)) {
    return flatten<string>(
      map(rawValue, (rawValueItem) => {
        return getReferencedIdsWorker(rawValueItem)
      }),
    )
  }

  console.warn('Unexpected reference format')
  return []
}
